<template>
  <transition-group tag="ul" :name="transition" v-bind:class="{ blog__feed_home: !reading }" class="blog__feed">
    <li v-for="post in feed" v-bind:class="{ preview: reading, feedPreview: !reading }" :key="post.id">
      
       <section v-if="!reading" class="feedPreview__postfeed">
          <time class="feedPreview__published">
            {{ prettyDate(post.published) }}
          </time>

          <h3 class="feedPreview__title">
            <router-link :to="`/read/${post.id}`"> {{ post.title }}</router-link>
          </h3>

          <div class="feedPreview__summary-tags-container">
              <span v-for="tag in post.tags" :key="tag" class="summary-article-tag">{{tag}}</span>
          </div>

          <router-link class="continue-reading" :to="`/read/${post.id}`" @click.native="scrollTo(0, 220, scrollDelay)">Continue Reading</router-link>

        </section>

      <figure v-if="reading" class="preview__figure" :class="figureClass">
        <img src="../assets/me.jpg"/>

        <h3 class="preview__figure__about">About Me:</h3>
        <p>
          Hi, I am Gerade Geldehuys, I'm a software engineer at <a class="bbd" href="https://bbd.co.za" target="_blank" title="BBD Software Development">BBD Software Development</a> who loves the web, mobile, cloud and all things .NET, residing in Pretoria, South Africa.
        </p>
        <p>
          My call to action here is to share the knowledge I encounter on a daily basis as a software developer, and my hope is that you'd come along for the journey and perhaps learn something.
        </p>

        <transition name="v--fade">

          <!-- <figcaption v-if="!reading || $device.phone">
            

            <div class="preview__meta">
              <time class="preview__published">
                {{ prettyDate(post.published) }}
              </time>

              <router-link class="preview__author"
                :to="`/by/${kebabify(post.author)}`"
                @click.native="scrollTo(0, 220, scrollDelay)">
                {{ post.author }}
              </router-link>
            </div>
          </figcaption> -->
        </transition>
      </figure>
    </li>
  </transition-group>
</template>

<script>
import { scrollTo, kebabify, prettyDate } from '../helpers'

export default {
  name: 'blog-feed',
  resource: 'BlogFeed',

  props: {
    filters: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      posts: [],
      transition: 'preview-appear'
    }
  },

  computed: {
    reading() {
      return this.filters.post
    },
    scrollDelay() { return (this.$device.phone) ? 0 : 560 },
    figureClass() {
      return { 'preview__figure--mobile': this.$device.phone && this.reading }
    },
    feed() {
      const filterBy = {
        post: (filter, { id }) => filter === id,
        author: (filter, { author }) => filter === this.kebabify(author)
      }

      if (!Object.keys(this.filters).length) return this.posts

      return this.posts.filter(post => {
        return Object.keys(this.filters).every(filter => {
          return filterBy[filter](this.filters[filter], post)
        })
      })
    }
  },

  methods: {
    scrollTo,
    kebabify,
    prettyDate,
    getBgImg(src) {
      return { backgroundImage: `url(../assets/me.jpg)` }
    },
    stackPosts(posts) {
      let interval
      const stack = () => {
        this.posts.push(posts.shift())

        if (!posts.length) {
          this.transition = 'preview'
          clearInterval(interval)
        }
      }

      interval = setInterval(stack, 125)
    },
    publishedPosts(posts) {
      var publishedPostsOnly = posts.filter(item => {
        return new Date(item.published) < new Date();
      });

      return publishedPostsOnly;
    }
  },
  metaInfo () {
    return {
      title: "Gerade Geldenhuys | .NET Developer",
      meta: [
        { vmid: 'description', name: 'description', content: "Gerade Geldenhuys | .NET Developer"},
        { vmid: 'og:title', name: 'og:title', content: "Gerade Geldenhuys | .NET Developer" },
        { vmid: 'og:description', name: 'og:description', content: "Gerade Geldenhuys | .NET Developer" },
        { vmid: 'twitter:image:src', name: 'twitter:image:src', content: "https://geradewebsitestorage.blob.core.windows.net/website/img-card.png" },
        { vmid: 'twitter:title', name: 'twitter:title', content: "Gerade Geldenhuys | .NET Developer" },
        { vmid: 'twitter:description', name: 'twitter:description', content: "" } 
      ]
    }
  },
  mounted() {
    this.$getResource('feed')
      .then(posts => {
        if (!Object.keys(this.filters).length) {
          posts = this.publishedPosts(posts);
          this.stackPosts(posts);
        } else {
          this.posts = posts;

          this.transition = 'preview'
        }
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BlogFeed.vue